/**
 * FO-B13: the portal API denies a custody-restricted guardian with HTTP 403 and the stable code
 * EDUCATION_PORTAL_CUSTODY_RESTRICTED (backend: education.people.access decideGuardianPortalAccess).
 * The code travels in `errors.code` of the ResponseUtil.error envelope (AppError.code).
 */
export const PORTAL_CUSTODY_RESTRICTED_CODE = 'EDUCATION_PORTAL_CUSTODY_RESTRICTED';

type ApiErrorLike = {
  response?: {
    status?: number;
    data?: { code?: string; errors?: { code?: string } | unknown[] | null } | null;
  };
};

export function isPortalCustodyRestricted(error: unknown): boolean {
  const response = (error as ApiErrorLike | null | undefined)?.response;
  if (!response || response.status !== 403) return false;
  const data = response.data;
  const nested = data && !Array.isArray(data.errors) ? (data.errors as { code?: string } | null | undefined)?.code : undefined;
  return (data?.code ?? nested) === PORTAL_CUSTODY_RESTRICTED_CODE;
}
